enum ServiceResponseErrorCode {
    NoError = 0,
    ValidationError = 400,
    AuthorizationError = 401,
    AuthenticationError = 403,
    NotFound = 404,
    Conflict = 409,
    SystemError = 500
};

export { ServiceResponseErrorCode };